import React from "react";
import styled from "styled-components";
import { Translation } from "../../../core/translate";
import { vstStore, brandSpecificApps } from "../header/menu-items/apps";
import { cloud } from "@vitalsource/vstui/colors";

const Wrapper = styled.div`
  align-items: center;
  background: #ffffff;
  border: 2px solid ${cloud.getShade(6)};
  border-radius: 10px;
  color: ${cloud.getShade(8)};
  display: flex;
  height: 64px;
  width: 521px;
  .name {
    border-right: 1px solid ${cloud.getShade(8)};
    margin-left: 24px;
    margin-right: 8px;
    padding-right: 8px;
  }
  .smarter {
    font-style: italic;
  }

  ul {
    display: flex;
    margin-left: auto;
    margin-right: 15px;
    width: 170px;
  }
`;

const IconList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;

  li {
    a {
      display: flex;

      img {
        border: 2px solid #e65f14;
        border-radius: 50%;
        box-sizing: content-box;
        height: 30px;
        padding: 4px;
        width: 30px;
      }
    }
  }
`;

const CheggFooterRight = () => {
  const elements = [vstStore()].concat(brandSpecificApps()).filter(el => !!el);
  return (
    <Wrapper>
      <span className="name">Chegg</span>
      <span className="smarter">
        <Translation id="chegg.smarter-way" />
      </span>
      <IconList>
        {elements.map(({ customIcon, onClick, text }) => {
          return (
            <li>
              <a href="#" onClick={onClick}>
                <img src={customIcon} alt={text} />
              </a>
            </li>
          );
        })}
      </IconList>
    </Wrapper>
  );
};

export default CheggFooterRight;
